import { useEffect, useState, type FC } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@/ds/custom/Modal";
import { Selector } from "@/ds/custom/Selector";
import { Button } from "@/ds/shadcn/components/ui/button";
import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { ErrorDisplay } from "@/lib/common/ErrorDisplay";
import { CurrencyOptions, type Currency } from "@/lib/domain/Currency";
import type { ProblemResponse } from "@/lib/http";

export interface ModalCurrencyProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	value: Currency;
	onConfirm: (currency: Currency) => void;
	isLoading?: boolean;
	error?: ProblemResponse | null;
}

export const ModalCurrency: FC<ModalCurrencyProps> = props => {
	const {
		open,
		onOpenChange,
		value,
		onConfirm,
		isLoading = false,
		error
	} = props;

	const [selected, setSelected] = useState<Currency>(value);

	useEffect(() => {
		setSelected(value);
	}, [value, open]);

	return (
		<Modal open={open} onOpenChange={onOpenChange} preventCloseOnInteractOutside={isLoading}>
			<ModalHeader>
				<ModalTitle>Change Currency</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="flex flex-col gap-3">
					<Selector
						className="w-full"
						value={selected}
						onChange={setSelected}
						placeholder="Select currency"
						options={CurrencyOptions}
						disabled={isLoading} />

					<ErrorDisplay error={error} />
				</div>
			</ModalBody>
			<ModalFooter>
				<Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
					Cancel
				</Button>
				<Button onClick={() => onConfirm(selected)} disabled={isLoading}>
					{isLoading ? <Spinner /> : <>Apply</>}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
